export const ServicePageColors = {
  "midnight": {
    "backgroundColor": "midnight",
    "headingColor": "white",
    "contentColor": "white",
    "footNotes": "white",
    "buttonText": "white",
  },
  "forest": {
    "backgroundColor": "forest",
    "headingColor": "white",
    "contentColor": "white",
    "footNotes": "white",
    "buttonText": "white",
  },
  "grass": {
    "backgroundColor": "grass",
    "headingColor": "white",
    "contentColor": "white",
    "footNotes": "white",
    "buttonText": "white",
  },
  "mint": {
    "backgroundColor": "mint",
    "headingColor": "forest",
    "contentColor": "tarmac",
    "footNotes": "thick-fog",
    "buttonText": "white",
  },
  "pale-piggy": {
    "backgroundColor": "pale-piggy",
    "headingColor": "forest",
    "contentColor": "tarmac",
    "footNotes": "thick-fog",
    "buttonText": "white",
  },
  "white": {
    "backgroundColor": "white",
    "headingColor": "text-title-regular",
    "contentColor": "text-title-regular",
    "footNotes": "text-title-regular",
    "buttonText": "white",
  },
  "grey": {
    "backgroundColor": "grey",
    "headingColor": "forest",
    "contentColor": "tarmac",
    "footNotes": "thick-fog",
    "buttonText": "white",
  },
  "pale-slate": {
    "backgroundColor": "pale-slate",
    "headingColor": "text-title-regular",
    "contentColor": "text-title-regular",
    "footNotes": "text-title-regular",
    "buttonText": "white",
  },
  "light-grey": {
    "backgroundColor": "light-grey",
    "headingColor": "text-title-regular",
    "contentColor": "text-title-regular",
    "footNotes": "text-title-regular",
    "buttonText": "white",
  },
  "aubergine": {
    "backgroundColor": "accentBase-primary-strong",
    "headingColor": "white",
    "contentColor": "white",
    "footNotes": "text-title-regular",
    "buttonText": "white",
  },
};

